import { gql } from '@apollo/client';

import META_FRAGMENT from '../fragments/meta';
import TRANSACTION_TYPES_FRAGMENT from '../fragments/services/transactionTypes';
import TRANSACTION_TYPES_USER_PRICE_FRAGMENT from '../fragments/services/userPrice';

export const findTransactionTypes = gql`
  ${TRANSACTION_TYPES_FRAGMENT}
  ${META_FRAGMENT}
  query findSTransactionTypes($pagination: PageOptionsDto) {
    findSTransactionTypeEntity(pagination: $pagination) {
      data {
        ...TransactionTypesFragment
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const findOneTransactionTypeEntity = gql`
  ${TRANSACTION_TYPES_FRAGMENT}
  query findOneTransactionTypeEntity($id: String) {
    findOneTransactionTypeEntity(id: $id) {
      ...TransactionTypesFragment
    }
  }
`;

export const findSpecificTransactionTypeByUser = gql`
  ${TRANSACTION_TYPES_USER_PRICE_FRAGMENT}
  query findTransactionTypeEntity($user: String, $pagination: PageOptionsDto) {
    findTransactionTypeEntity(pagination: $pagination) {
      data {
        id
        ...TransactionTypesUserPriceFragment
      }
    }
  }
`;
